












import { Component, Vue } from 'vue-property-decorator';
import MouseComponent from '@/components/elements/Mouse.vue';
import Lang from '@/components/elements/Lang.vue';

@Component({
  components: {
    MouseComponent,
    Lang
  },
})
export default class Hero extends Vue {
}
